module.exports = __webpack_public_path__ + "93b60ad98e05bc97b906edcd1335e329.svg";